import { call, put } from "redux-saga/effects";
import { api } from "../../../services";
import { Creators } from "./index";

import { Alerts } from "../../../lib";

export default function* unblockUserAmcred({ data, callback }) {
  try {
    yield call(api.unblockUserAmcred, data);

    yield put(Creators.newUserAmcredSuccess());

    callback();
  } catch (response) {
    Alerts.alertError(
      response?.data?.log
        ? response?.data?.log
        : "Não foi possível desbloquear o usuário"
    );

    yield put(Creators.newUserAmcredFailure());
  }
}
